import "./Checkout.module.css";
import WebsiteHeader from "@/reusable_sections/Header";
import CheckoutContent from "./sections/CheckoutContent";
import Footer from "@/reusable_sections/Footer";
export default function CheckoutPage() {
  return <div>
      <WebsiteHeader />
      <CheckoutContent />
      <Footer />
    </div>;
}